import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

//const fetchAllSimple = () => initialState;

const setAll = (state, { allProductAttribute }) => {
  if (!allProductAttribute) return state;
  return state.merge({ allProductAttribute });
};

const setAllProductAttributesOptions = (state, { allProductAttributeOptions }) => {
  if (!allProductAttributeOptions) return state;
  return state.merge({ allProductAttributeOptions });
};

const setAllDataTypes = (state, { allDataTypes }) => {
  if (!allDataTypes) return state;
  return state.merge({ allDataTypes });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllGlobalAttributes = (state, { allGlobalAttributes }) => {
  return state.merge({ allGlobalAttributes });
};

const setGlobalAttributeExportDataLoader = (state, { showGlobalAttributeExportDataLoader }) => {
  return state.merge({ showGlobalAttributeExportDataLoader });
};

const setProductAttributeById = (state, { productAttributeById }) => {
  if (!productAttributeById) return state;
  return state.merge({ productAttributeById });
};

const setGlobalAttributesDataExport = (state, { globalAttributeExportCSVData }) => {
  if (!globalAttributeExportCSVData) return state;
  return state.merge({ globalAttributeExportCSVData });
};

const setImportExcelToolFile = (state, { importProductAttributeFile }) => {
  return state.merge({ importProductAttributeFile });
};

const setImportExcelToolFileLoader = (state, { importExcelFileLoader }) => {
  return state.merge({ importExcelFileLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_PRODUCT_ATTRIBUTES_OPTIONS,
    actionFunction: setAllProductAttributesOptions,
  },
  {
    actionType: ActionTypes.SET_DATA_TYPES,
    actionFunction: setAllDataTypes,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ATTRIBUTE_BY_ID,
    actionFunction: setProductAttributeById,
  },
  {
    actionType: ActionTypes.SET_ALL_GLOBAL_ATTRIBUTES,
    actionFunction: setAllGlobalAttributes,
  },
  {
    actionType: ActionTypes.SET_EXPORT_GLOBAL_ATTRIBUTE_DATA,
    actionFunction: setGlobalAttributesDataExport,
  },
  {
    actionType: ActionTypes.SET_EXPORT_GLOBAL_ATTRIBUTE_DATA_EXPORT_LOADER_STATUS,
    actionFunction: setGlobalAttributeExportDataLoader,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE,
    actionFunction: setImportExcelToolFile,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE_LOADER_STATUS,
    actionFunction: setImportExcelToolFileLoader,
  },
];
